<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <section>
          <v-card
            flat>
            <v-tabs
              v-model="selected.menu"
              background-color="transparent"
              color="#ff64ad"
              slider-size="5"
              show-arrows
              next-icon="mdi-arrow-right-bold-box-outline"
              prev-icon="mdi-arrow-left-bold-box-outline"
              dense
              grow
              class="d-flex justify-start tabs-stream">
              <v-tab
                v-for="(item, index) in menu"
                :key="index"
                class="px-0 mr-4 d-flex align-center">
                <v-avatar
                  tile
                  size="20">
                  <v-img 
                    contain
                    :src="item.icon">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          size="20"
                          color="#ff64ad">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>

                <span 
                  class="body-2 text-capitalize ml-2" 
                  :class="selected.menu === index ? 'font-weight-bold' : 'text-third'">
                  {{ item.title }}
                </span>
              </v-tab>
            </v-tabs>

            <div>
              <Category v-if="selected.menu === 0"
                :detail="menu[selected.menu]" />

              <News v-if="selected.menu === 1"
                :detail="menu[selected.menu]" />
            </div>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },
        menu: [
          {
            title: 'Kategori',
            icon: require('@/assets/image/category.png')
          },
          {
            title: 'Berita',
            icon: require('@/assets/image/news.png')
          }
        ]
      }
    },
    components: {
      Category: () => import(/* webpackPrefetch: true */ '@/components/news/category.vue'),
      News: () => import(/* webpackPrefetch: true */ '@/components/news/news.vue')
    },
    computed: {
      
    },
    watch: {
      
    },
    mounted () {
      
    },
    methods: {
      
    }
  }
</script>